module.exports = __webpack_public_path__ + "img/TheosLogo.aff18365.png";